import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { FirebaseAuthService } from './firebase-auth.service';

export const authGuard: CanActivateFn = () => {
    const auth = inject(FirebaseAuthService);
    const router = inject(Router);

    return from(auth.whenReady()).pipe(
        map((u) => (u ? true : router.createUrlTree(['/login'])))
    );
};
